import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { observable, computed } from "mobx";
/**
 * LanguageListDataService
 */
export class LanguageListDataService extends DataService<typeof Model.Core.Logic.ViewModels.LanguageSummary, Model.Core.Logic.ViewModels.LanguageSummary, LanguageSummary> {
    protected map(entity: Model.Core.Logic.ViewModels.LanguageSummary): LanguageSummary {
        return new LanguageSummaryModel(entity);
    }

    public static make(context?: any): LanguageListDataService {
        return new LanguageListDataService(context, ctx => ctx.LanguagesSummaries);
    }
}

export class LanguageSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.LanguageSummary, LanguageSummary> implements LanguageSummary {
    
    @property<LanguageSummaryModel>(o => o.entity.languageCode, (o, value) => o.entity.languageCode = value)
    public languageCode: string;

    @property<LanguageSummaryModel>(o => o.entity.flag, (o, value) => o.entity.flag = value)
    public flag: Uint8Array;

    @property<LanguageSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;
}


// WEBPACK FOOTER //
// ./src/core/ui/language/language.data.ts